<template>
  <div>	
		<!-- <div style="line-height: 1.8em; color: #666; text-indent: 2em;" v-text="result.other.subtitle"></div> -->
		<div class="result-bar-wrap t3" style="margin-bottom: 50px;">
			<div class="tab-0" v-if="result.level === 1">低风险</div>
			<div class="tab-1" v-if="result.level === 2">中风险</div>
			<div class="tab-2" v-if="result.level === 3">高风险</div>
			<div class="r-bar"></div>
			<div v-if="result.level === 1" class="c-0"></div>
			<div v-else-if="result.level === 2" class="c-1"></div>
			<div v-else-if="result.level === 3" class="c-2"></div>
			<div style="font-size:20px;">
				您本次的运动风险评估结果为：
				<span v-if="result.level === 1" class="t-0">低风险</span>
				<span v-else-if="result.level === 2" class="t-1">中风险</span>
				<span v-else-if="result.level === 3" class="t-2">高风险</span>
			</div>
		</div>
		<table>
			<tr>
				<th>与运动风险相关的危险因素</th>
				<th>本次评估结果</th>
				<th>上次评估结果</th>
			</tr>
			<tr v-for="item in Object.keys(result.other.riskFactors)" :key="item">
				<td>{{ result.other.riskFactors[item].name }}</td>
				<td>
					<span v-if="result.other.riskFactors[item].value && result.other.riskFactors[item].key != 'sum'">✓</span>
					<span v-if="result.other.riskFactors[item].value && result.other.riskFactors[item].key == 'sum'">{{result.other.riskFactors[item].value}}</span>
				</td>
				<td></td>
			</tr>
		</table>
		<template v-if="result.other?.suggest">
		<h4>体力活动建议</h4>
		<div>
			<p style="line-height: 1.8em; color: #666; text-indent: 2em;" v-for="(item, index) in result.other.suggest" :key="index" v-text="item"></p>
		</div>
		</template>
  </div>

</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';

export default {  
	props: {
		result: Object
	},
	// watch: {
	// 	visible() {
	// 		if (this.visible) {
	// 			this.filter.type = this.type;
	// 			this.loadList();
	// 		}
	// 	}
	// },	
	data(){
		return {}
	},
	created() {
		console.log(this.result,'----result');
	},
	methods: {}
}
</script>

<style lang="less" scoped>
// @import './template.less';	
</style>
